import { Component, OnDestroy, OnInit } from '@angular/core';
import { PlaylistsService } from '../../core/services/playlists.service';
import { PlaylistDto, TokensDto } from '../../core/models/api.models';

@Component({
  selector: 'app-playlists',
  templateUrl: './playlists.page.html',
  styleUrls: ['./playlists.page.scss']
})
export class PlaylistsPage implements OnInit, OnDestroy {
  playlists: PlaylistDto[] = [];
  loading = false;
  pollTimer?: any;
  page = 1;
  limit = 20;
  total = 0;
   tokens?: TokensDto | null;

  constructor(private playlistsService: PlaylistsService) {}

  ngOnInit(): void {
    this.fetch();
    this.loadTokens();
    this.pollTimer = setInterval(() => this.fetch(true), 5000);
  }

  ngOnDestroy(): void {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
    }
  }

  fetch(skipLoading = false): void {
    if (!skipLoading) {
      this.loading = true;
    }
    this.playlistsService.listMine(this.page, this.limit).subscribe({
      next: res => {
        const filtered = res.items.filter(p => p.status !== 'FAILED');
        this.playlists = filtered.map(p => ({
          ...p,
          progress:
            typeof p.progress === 'number'
              ? p.progress
              : p.processedCount && p.total
              ? Math.round((p.processedCount / p.total) * 100)
              : p.progress
        }));
        this.total = res.total;
        this.page = res.page;
        this.limit = res.limit;
        this.loading = false;
      },
      error: () => (this.loading = false)
    });
  }

  loadTokens(): void {
    this.playlistsService.getMyTokens().subscribe({
      next: res => (this.tokens = res),
      error: () => (this.tokens = null)
    });
  }

  delete(id: string): void {
    this.playlistsService.deleteMine(id).subscribe(() => {
      this.playlists = this.playlists.filter(p => p.id !== id);
    });
  }

  nextPage(): void {
    if (this.page * this.limit < this.total) {
      this.page += 1;
      this.fetch();
    }
  }

  prevPage(): void {
    if (this.page > 1) {
      this.page -= 1;
      this.fetch();
    }
  }

  totalPages(): number {
    if (!this.total) {
      return 1;
    }
    return Math.max(1, Math.ceil(this.total / this.limit));
  }
}
